import { Card, AccordionCollapse, Stack, FormGroup, FormLabel, FormCheck } from "react-bootstrap"
import { SectionIndicators } from "./Common"
import { Technology } from "../Types/data"
import { SectionProps, TechnologyField } from "../Types/calculator"
import { isSectionComplete } from "../Utilities/constants"
import { data } from "../Utilities/data"
import _ from "lodash"

export function Technologies(props: SectionProps<TechnologyField>) {
  const { state, setSettings, onCategorySelected, section } = props
  const { technologies, expandedSections } = state

  const onTechnologiesChanged = (_ev: any, technology: Technology) => {
    let newTechnologies = _.cloneDeep(technologies)
    const existing = newTechnologies.find((t) => t.name === technology.name)
    existing ? (newTechnologies = newTechnologies.filter((t) => t.name !== technology.name)) : newTechnologies.push(technology)

    const newCalculatedCostPerUnit = newTechnologies.reduce((total, technology) => total + (technology.unitCost || 0), 0)

    setSettings({ technologies: newTechnologies, calculatedCostPerUnit: newCalculatedCostPerUnit })
  }

  const complete = isSectionComplete(state, section)

  return (
    <Card id={section.name}>
      <Card.Header
        tabIndex={1}
        onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onCategorySelected(section.name)}
        as="h3"
        onClick={() => onCategorySelected(section.name)}
      >
        <div style={{ fontWeight: complete && expandedSections.includes(section.name) ? "lighter" : "inherit" }}>{section.name}</div>
        <SectionIndicators
          error={expandedSections.includes(section.name) && !complete}
          complete={complete}
          tooltipMessage="Check any combination of technologies your fleet would like to evaluate. These can be changed later."
        />
      </Card.Header>
      <AccordionCollapse className="IncludeInExport" eventKey={section.name}>
        <Card.Body>
          <Stack gap={2}>
            {data.technologies.map((t, i) => {
              return (
                <FormGroup key={`${t.id}`} title={t.description || t.name}>
                  <FormLabel aria-label={t.description || t.name}>
                    <FormCheck
                      tabIndex={i + 1}
                      inline
                      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onTechnologiesChanged(e, t)}
                      checked={technologies.some((tt) => tt.id === t.id)}
                      onChange={(ev) => onTechnologiesChanged(ev, t)}
                    />
                    {t.name}
                  </FormLabel>
                </FormGroup>
              )
            })}
          </Stack>
        </Card.Body>
      </AccordionCollapse>
    </Card>
  )
}